export default function setTitle (title: string): void {
  document.title = title + ' - Lexicl'
}
